// extracted by mini-css-extract-plugin
module.exports = {"login":"Auth_login__3hAey","form":"Auth_form__3qKeq","fieldset":"Auth_fieldset__1QzWN","link":"Auth_link__1fOlj"};